<template>
  <nav
    id="navbarBlur"
    :class="`${
      !isNavFixed
        ? 'navbar navbar-main navbar-expand-lg px-0 mx-4 border-radius-xl shadow-none'
        : `navbar navbar-main navbar-expand-lg px-0 mx-4 border-radius-xl shadow-none position-sticky ${
            darkMode ? 'bg-default' : 'bg-white'
          } left-auto top-2 z-index-sticky`
    } ${isRTL ? 'top-0 position-sticky z-index-sticky' : ''}`"
    v-bind="$attrs"
    data-scroll="true"
  >
    <div class="px-3 py-1 container-fluid">

      <div
        id="navbar"
        class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="isRTL ? 'px-0' : 'me-sm-4'"
      >
        <div
          class="col-md-4 pe-md-3 d-flex align-items-center"
          :class="isRTL ? 'me-md-auto' : 'ms-md-auto'"
          v-show="showTopSearch"
        >
          <div class="input-group">
            <span class="input-group-text text-body">
              <i class="fas fa-search" aria-hidden="true"></i>
            </span>
            <input
              type="text"
              class="form-control"
              :placeholder="isRTL ? 'أكتب هنا...' : 'Type here...'"
            />
          </div>
        </div>
        <ul class="navbar-nav justify-content-end ms-md-auto">
          <!-- <li class="nav-item d-flex align-items-center">
            <router-link
              :to="{ name: 'Signin Basic' }"
              class="px-0 nav-link font-weight-bold"
              :class="
                isNavFixed && !darkMode ? ' opacity-8 text-dark' : 'text-white'
              "
              target="_blank"
            >
              <i class="fa fa-user" :class="isRTL ? 'ms-sm-2' : 'me-sm-1'"></i>
              <span v-if="isRTL" class="d-sm-inline d-none">يسجل دخول</span>
              <span v-else class="d-sm-inline d-none">Sign In</span>
            </router-link>
          </li> -->
          <li
            class="nav-item dropdown d-flex align-items-center dropdown loginform"
            :class="isRTL ? 'ps-2' : 'pe-2'"
            v-if="!user.uid"
          >
            <a
              id="dropdownMenuButton"
              href="#"
              :class="`p-0 nav-link ${
                isNavFixed && !darkMode ? ' opacity-8 text-dark' : 'text-white1'
              } ${showMenu ? 'show' : ''}`"              
              @click="showMenu = !showMenu"
            >
              <i class="fa fa-user" :class="isRTL ? 'ms-sm-2' : 'me-sm-1'"></i>
              <span v-if="isRTL" class="d-sm-inline d-none">يسجل دخول</span>
              <span v-else class="d-sm-inline d-none">Admin Login</span>
            </a>
            <ul
              class="px-2 py-3 dropdown-menu dropdown-menu-end dropdown-lg me-sm-n4"
              :class="showMenu ? 'show' : ''"
              aria-labelledby="dropdownMenuButton"
              style="margin-top:10px !important;"
            >
              <li class="mb-2">


                <LoginForm @login="enterSetup" />


              </li>
            </ul>
          </li>
          <li v-else>
            <a
              id="dropdownMenuButton"
              href="#"
              :class="`p-0 nav-link ${
                isNavFixed && !darkMode ? ' opacity-8 text-dark' : 'text-white1'
              } ${showMenu ? 'show' : ''}`"              
              @click="user_logout"
            >
              Logout
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  import getUser from "@/composables/getUser"
import { mapState, mapMutations, mapActions } from "vuex";
import LoginForm from '@/components/custom/LoginForm.vue';
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import useLogout from '@/composables/useLogout'
import getUserInfo from '@/composables/getUserInfo'
export default {
  name: "NavbarFront",
  components: {
    LoginForm
  },
  setup(){ 
    const showLogin = ref(true);
    const router = useRouter();
    const { logout } = useLogout()
    const { user } = getUser();
    const { user_info_error, user_info, load_user_info } = getUserInfo();
    const enterSetup = () => {
      /* console.log("Enter Setup Called!");
      router.push({ name: 'Articles' }) */
    }
    const user_logout = async () => {
      //await load_user_info();
      await logout()
         this.$store.dispatch('printLog', {log:'logged out'})
      //router.push({ name: 'Home', params: { library_key: user_info.value.support_lib_id } })
      router.push({ name: 'Manage' })
    }
    return { showLogin, enterSetup, user, user_logout }
  },
  data() {
    return {
      showMenu: false,
      showTopSearch: false
    };
  },
  computed: {
    ...mapState(["isRTL", "isNavFixed", "darkMode", "showTopSearch"]),
    currentRouteName() {
      return this.$route.name;
    },
    currentDirectory() {
      let dir = this.$route.path.split("/")[1];
      return dir.charAt(0).toUpperCase() + dir.slice(1);
    }
  },
  created() {
    this.minNav;
  },
  beforeUpdate() {
    this.toggleNavigationOnMobile();
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions(["toggleSidebarColor"]),
    toggleNavigationOnMobile() {
      if (window.innerWidth < 1200) {
        this.navbarMinimize();
      }
    },
  }
};
</script>